import { getUserProfileInfoApi } from 'redux/apis/Users';
import { fetchError, fetchStart, fetchSuccess, postSuccess } from './Common';
import { 
  getCarrierDetailsByIdApi, getCarrierDetailsByUserIdApi, 
  getInterestSentUsersApi,postCommentForCarrierApi, 
  getCommentsHistoryForCarrierApi, getQuestinnareForCarrierApi, 
  postQuestinnareForCarrierApi, getShaTemplateApi, updateCarrierDetailsByIdApi, sendCarrierPacketApi,
  getLaneInterestsByUsersIdApi, getOnboardingStatusUpdatesApi,
  putOnboardingStatusUpdatesApi, sendShaTemplateByCarrierIdApi,
  getUserDetailsByIdApi,
  fetchCarrierDocumentsApi,
  updateComplianceForCarrierApi,
  acceptOrRejectUserUploadedDocApi,
  submitAdminUploadedDocsForCarrierApi,
  getCommentsForUserApi,
  addAdminCommentForDocRejectApi,
  deleteDocumentUploadedByAdminByNameApi,
  deleteDocumentUploadedByAdminByIdApi,
  bulkUploadLanesApi,
  getAdminUploadedLanesWithFilterApi,
  updateUserCommunicationHistoryApi,
  addUserCommunicationHistoryApi,
  fetchUserCommunicationHistoryApi,
  getUserCarrierInfoFromExternalSourcesApi,
  getCarrierLanePreferencesApi,
  postCarrierLanePreferencesApi,
  updateCarrierLanePreferencesApi,
  deleteCarrierLanePreferencesApi
} from 'redux/apis/Lanes';

export const GET_INTEREST_SENT_USERS_SUCCESS = "GET_INTEREST_SENT_USERS_SUCCESS"
export const getInterestSentUsers = (filterOptions = [], showLoader=true) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      if(showLoader)dispatch(fetchStart());
      // dispatch({ type: GET_INTEREST_SENT_USERS_SUCCESS });
      getInterestSentUsersApi(filterOptions)
        .then(data => {
          dispatch({ type: GET_INTEREST_SENT_USERS_SUCCESS, payload: data.data });
          if(showLoader)dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while fetching data'));
          reject(error);
        });
    });
  };
};

export const GET_CARRIER_DETAILS = "GET_CARRIER_DETAILS";
export const getCarrierDetailsById = (carrier_id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getCarrierDetailsByIdApi(carrier_id)
        .then(data => {
          dispatch({ type: GET_CARRIER_DETAILS, payload: data });
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while fetching data'));
          reject(error);
        });
    });
  };
};

export const updateUserCarrierDetails = (data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({ type: GET_CARRIER_DETAILS, payload: data });
      resolve(data);
    });
  };
};

export const getCarrierDetailsByUserId = (user_id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      dispatch(setCarrierDetailsLoading(true))
      getCarrierDetailsByUserIdApi(user_id)
        .then(data => {
          dispatch({ type: GET_CARRIER_DETAILS, payload: data?.data ?? {} });
          dispatch(fetchSuccess());
          resolve(data?.data ?? {});
          dispatch(setCarrierDetailsLoading(false))
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while fetching data'));
          reject(error);
        });
    });
  };
};

export const GET_COMMENTS_HISTORY_FOR_CARRIER_SUCCESS = "GET_COMMENTS_HISTORY_FOR_CARRIER_SUCCESS"
export const getCommentsHistoryForCarrier = (carrier_id, data={}) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getCommentsHistoryForCarrierApi(carrier_id, data)
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while fetching data'));
          reject(error);
        });
    });
  };
};

export const POST_COMMENT_FOR_CARRIER_SUCCESS = "POST_COMMENT_FOR_CARRIER_SUCCESS"
export const postCommentForCarrier = (data, user_id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      postCommentForCarrierApi(data, user_id)
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured'));
          reject(error);
        });
    });
  };
};

export const GET_QUESTINNIARE_SUCCESS = "GET_QUESTINNAIRE_SUCCESS"
export const getQuestinnareForCarrier = (carrier_id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getQuestinnareForCarrierApi(carrier_id)
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while fetching data'));
          reject(error);
        });
    });
  };
};

export const POST_QUESTINNIARE_SUCCESS = "POST_QUESTINNAIRE_SUCCESS"
export const postQuestinnareForCarrier = (data, carrier_id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      postQuestinnareForCarrierApi(data, carrier_id)
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured'));
          reject(error);
        });
    });
  };
};


export const SEND_CARRIER_PACKET = "SEND_CARRIER_PACKET"
export const sendCarrierPacketByMC = (data, carrier_id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      sendCarrierPacketApi(data, carrier_id)
      .then(data => {
        dispatch(fetchSuccess());
        resolve(data);
      })
      .catch(error => {
        dispatch(fetchError('Some error occured while fetching data'));
        reject(error);
      });
  });
};
};

export const getShaTemplate = () => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getShaTemplateApi()
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while fetching data'));
          reject(error);
        });
    });
  };
};

export const updateCarrierDetails = (carrier_id, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      updateCarrierDetailsByIdApi(carrier_id, data)
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while fetching data'));
          reject(error);
        });
    });
  };
};

export const sendShaTemplateByCarrierId = (carrier_id, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      sendShaTemplateByCarrierIdApi(carrier_id, data)
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while sending the template'));
          reject(error);
        });
    });
  };
};

export const UPDATE_SHA_STATUS_LOCALLY = "UPDATE_SHA_STATUS_LOCALLY"
export const updateShaStatusLocally = (status) => {
  return dispatch => {
    dispatch({
      type:UPDATE_SHA_STATUS_LOCALLY,
      payload:status
    });
  };
};

//use it only for removing any documents that are not saved in DB
export const CLEAR_ADMIN_UPLOADED_DOCS= "CLEAR_ADMIN_UPLOADED_DOCS"
export const clearAdminUploadedDocForCarrier = (urlList=[]) => {
  return dispatch => {
    urlList.forEach(url =>{ 
      let doc_full_path = url.split("amazonaws.com")[1]
      console.log("doc_full_path", doc_full_path)
      let basePath = doc_full_path.split("/").slice(0, -1).join("/").slice(1)+"/"
      let document_name = doc_full_path.split("/").slice(-1)[0]
      deleteDocumentUploadedByAdminByNameApi({
        path:basePath,
        document_name:document_name
      })
    })
    dispatch({
      type:CLEAR_ADMIN_UPLOADED_DOCS,
      payload:null
    });
  };
}

export const clearAdminUploadedDocForCarrierLocally = () => {
  return dispatch => {
    dispatch({
      type:CLEAR_ADMIN_UPLOADED_DOCS,
      payload:null
    });
  };
}


export const getUserDetailsById = (user_id, isLoading=true) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      isLoading && dispatch(fetchStart());
      getUserDetailsByIdApi(user_id)
        .then(data => {
          isLoading && dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          isLoading && dispatch(fetchError('Some error occured while fetching user data'));
          reject(error);
        });
    });
  };
};

export const getLaneInterestsByUserId = (user_id, data) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      // dispatch(fetchStart());
      getLaneInterestsByUsersIdApi(user_id, data)
        .then(data => {
          // dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured'));
          reject(error);
        });
    });
  };
};


export const getOnboardingStatusUpdates = (carrier_id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getOnboardingStatusUpdatesApi(carrier_id)
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while fetching onboarding data'));
          reject(error);
        });
    });
  };
};


export const updateOnboardingStatusUpdates = (data, carrier_id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      putOnboardingStatusUpdatesApi(data, carrier_id)
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured'));
          reject(error);
        });
    });
  };
};

export const GET_CARRIER_DOCUMENTS_SUCCESS = "GET_CARRIER_DOCUMENTS_SUCCESS"
export const fetchCarrierDocuments = (carrier_id) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      fetchCarrierDocumentsApi(carrier_id)
        .then(data => {
          dispatch(fetchSuccess());
          dispatch({
            type:GET_CARRIER_DOCUMENTS_SUCCESS,
            payload:data?.data?.documents ?? []
          })
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured'));
          reject(error);
        });
    });
  };
};

export const UPDATE_COMPLIANCE_LOCALLY = "UPDATE_COMPLIANCE_LOCALLY"
export function updateComplianceForCarrier(carrier_id, status){
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      updateComplianceForCarrierApi(carrier_id, {compliance_status:status})
        .then(data => {
          dispatch(fetchSuccess());
          dispatch({
            type:UPDATE_COMPLIANCE_LOCALLY,
            payload:status
          });
          resolve(data);
        })
        .catch(error => {
          fetchError("Something went wrong while updating the compliance status");
          reject(error);
        });
    });
  };
};


export function acceptOrRejectUserUploadedDoc(document_id, data){
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      acceptOrRejectUserUploadedDocApi(document_id, data)
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured'));
          reject(error);
        });
    });
  };
};

export function submitAdminUploadedDocsForCarrier(carrier_id, data){
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      submitAdminUploadedDocsForCarrierApi(carrier_id, data)
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured'));
          reject(error);
        });
    });
  };
};

export const ADD_ADMIN_UPLOADED_DOC_FOR_CARRIER = "ADD_ADMIN_UPLOADED_DOC_FOR_CARRIER"
export function addAdminUploadedDocForCarrier(file_url){
  return dispatch => {
    dispatch({
      type:ADD_ADMIN_UPLOADED_DOC_FOR_CARRIER,
      payload:file_url
    });
  }
};

//use it only for removing any documents that are not saved in DB
export const REMOVE_ADMIN_UPLOADED_DOC_FOR_CARRIER_BEFORE_SUBMIT = "REMOVE_ADMIN_UPLOADED_DOC_FOR_CARRIER_BEFORE_SUBMIT"
export function removeAdminUploadedDocForCarrierBeforeSubmit(file_url){
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      let doc_full_path = file_url.split("amazonaws.com")[1]
      let basePath = doc_full_path.split("/").slice(0, -1).join("/").slice(1)+"/"
      let document_name = doc_full_path.split("/").slice(-1)[0]
      console.log("doc_full_path", {
        path:basePath,
        document_name:document_name
      })
      deleteDocumentUploadedByAdminByNameApi({
        path:basePath,
        document_name:document_name
      })
        .then(data => {
          dispatch({
            type:REMOVE_ADMIN_UPLOADED_DOC_FOR_CARRIER_BEFORE_SUBMIT,
            payload:file_url
          });
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured'));
          reject(error);
        });
    });
  }
};

export const GET_CARRIER_COMMENTS_SUCCESS = "GET_CARRIER_COMMENTS_SUCCESS"
export const GET_CARRIER_COMMENTS_WITH_TYPE_SUCCESS = "GET_CARRIER_COMMENTS_SUCCESS_WITH_TYPE"
export function getCommentsForUser(user_id, commentType=null){
  return dispatch => {
    return new Promise((resolve, reject) => {
      // dispatch(fetchStart());
      let data = {
        limit:100,
      }
      if(commentType)data.type = commentType
      getCommentsForUserApi(user_id, data)
        .then(data => {
          if(commentType){
            dispatch({
              type:GET_CARRIER_COMMENTS_WITH_TYPE_SUCCESS,
              payload:data?.data?.comments ?? [],
              commentType:commentType
            })
          }else{
            dispatch({
              type:GET_CARRIER_COMMENTS_SUCCESS,
              payload:data?.data?.comments ?? []
            })
          }
          // dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured'));
          reject(error);
        });
    });
  };
};

export function addAdminCommentForDocReject(user_id, data){
  return dispatch => {
    return new Promise((resolve, reject) => {
      // dispatch(fetchStart());
      addAdminCommentForDocRejectApi(user_id, data)
        .then(data => {
          // dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured'));
          reject(error);
        });
    });
  };
}; 

//removes from s3 and backend
export function deleteDocumentUploadedByAdminById(document_id){
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      deleteDocumentUploadedByAdminByIdApi(document_id)
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured'));
          reject(error);
        });
    });
  };
};

export function deleteDocumentUploadedByAdminByName(file_url){
  return dispatch => {
    return new Promise((resolve, reject) => {
      let doc_full_path = file_url.split("amazonaws.com")[1]
      console.log("doc_full_path", doc_full_path)
      let basePath = doc_full_path.split("/").slice(0, -1).join("/").slice(1)+"/"
      let document_name = doc_full_path.split("/").slice(-1)[0]
      deleteDocumentUploadedByAdminByNameApi({
        path:basePath,
        document_name:document_name
      })
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured'));
          reject(error);
        });
    });
  };
};

export const CLEAR_COMMENTS_AND_DOCS_OF_CURRENT_USER = "CLEAR_COMMENTS_AND_DOCS_OF_CURRENT_USER"
export function clearCommentsAndDocsOfCurrentCarrier(){
  return dispatch => {
    dispatch({
      type:CLEAR_COMMENTS_AND_DOCS_OF_CURRENT_USER,
      payload:null
    });
  }
};

export function bulkUploadLanes(data){
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      bulkUploadLanesApi(data)
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while uploading lanes'));
          reject(error);
        });
    });
  };
};

export const FETCH_CARRIER_COMMUNICATION_HISTORY_SUCCESS = "FETCH_CARRIER_COMMUNICATION_HISTORY_SUCCESS";
export function fetchUserCommunicationHistory(user_id, showShimmer=false, showCommunicationAddedMessage=false){
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      if(showShimmer)dispatch(setCommunicationHistoryLoading(true));
      fetchUserCommunicationHistoryApi(user_id)
        .then(data => {
          dispatch({
            type:FETCH_CARRIER_COMMUNICATION_HISTORY_SUCCESS,
            payload:data?.data?.sort((a, b) => a.created_at - b.created_at) ?? []
          })
          dispatch(fetchSuccess());
          if(showCommunicationAddedMessage)dispatch(postSuccess("Communication added successfully"));
          dispatch(setCommunicationHistoryLoading(false))
          resolve(data);
        })
        .catch(error => {
          dispatch(setCommunicationHistoryLoading(false))
          dispatch(fetchError('Some error occured while getting communication history'));
          reject(error);
        });
    });
  };
};

export function getAdminUploadedLanesWithFilter(data){
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getAdminUploadedLanesWithFilterApi(data)
        .then(data => {
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while fetching lanes'));
          reject(error);
        });
    });
  };
};

export function addUserCommunicationHistory(user_id, data){
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      addUserCommunicationHistoryApi(user_id, data)
        .then(data => {
          dispatch(fetchUserCommunicationHistory(user_id, false, true))
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while adding communication history'));
          reject(error);
        });
    });
  };
};

export const UPDATE_COMM_HISTORY_LOCALLY = "UPDATE_COMM_HISTORY_LOCALLY"
export function updateUserCommunicationHistory(communication_id, data){
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      updateUserCommunicationHistoryApi(communication_id, data)
        .then(res => {
          dispatch(postSuccess("Communication history updated"));
          dispatch({
            type:UPDATE_COMM_HISTORY_LOCALLY,
            payload:{
              communication_id,
              data
            }
          })
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while updating communication history'));
          reject(error);
        });
    });
  };
};

export const SET_COMMUNICATION_HISTORY_LOADING = "SET_COMMUNICATION_HISTORY_LOADING"
function setCommunicationHistoryLoading(state){
  return dispatch => {
    dispatch({
      type:SET_COMMUNICATION_HISTORY_LOADING,
      payload:!!state
    })
  }
}

export const SET_CARRIER_DETAILS_LOADING = "SET_CARRIER_DETAILS_LOADING"
function setCarrierDetailsLoading(state){
  return dispatch => {
    dispatch({
      type:SET_CARRIER_DETAILS_LOADING,
      payload:!!state
    })
  }
}

export const CLEAR_ALL_CARRIER_DATA_LOCALLY = "CLEAR_ALL_CARRIER_DATA_LOCALLY"
export function clearAllCarrierDataLocally(){
  return dispatch => {
    dispatch({
      type:CLEAR_ALL_CARRIER_DATA_LOCALLY,
    })
  }
}

export const GET_CARRIER_DETAILS_EXTERNAL_SOURCES_SUCCESS = "GET_CARRIER_DETAILS_EXTERNAL_SOURCES_SUCCESS"
export function getUserCarrierInfoFromExternalSources(user_id){
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getUserCarrierInfoFromExternalSourcesApi(user_id)
        .then(res => {
          dispatch({
            type:GET_CARRIER_DETAILS_EXTERNAL_SOURCES_SUCCESS,
            payload:res.data
          })
          dispatch(fetchSuccess());
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError('Some error occured while fetching carrier information'));
          reject(error);
        });
    });
  };
};

export const GET_USER_PROFILE_INFO_SUCCESS = "GET_USER_PROFILE_INFO_SUCCESS"
export function getUserProfileInfo(user_id) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getUserProfileInfoApi(user_id)
        .then(res => {
          dispatch({
            type:GET_USER_PROFILE_INFO_SUCCESS,
            payload: res.user
          })
          dispatch(fetchSuccess());
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError((err.response && err.response.data.message) ?? "Some error occured while fetching user data"));
          reject(err);
        });
    });
  };
}

export const GET_CARRIER_LANE_PREFERENCES_SUCCESS = "GET_CARRIER_LANE_PREFERENCES_SUCCESS"
export function getCarrierLanePreferences(carrier_id, showLoader=true) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      if(showLoader)dispatch(fetchStart());
      getCarrierLanePreferencesApi(carrier_id)
        .then(res => {
          dispatch({
            type:GET_CARRIER_LANE_PREFERENCES_SUCCESS,
            payload: res?.data?.prefered_lanes ?? []
          })
          if(showLoader)dispatch(fetchSuccess());
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError((err.response && err.response.data.message) ?? "Some error occured while fetching lane preferences"));
          reject(err);
        });
    });
  };
}

export function postCarrierLanePreferences(carrier_id, data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      postCarrierLanePreferencesApi(carrier_id, data)
        .then(res => {
          dispatch(fetchSuccess());
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError((err.response && err.response.data.message) ?? "Some error occured while adding lane preferences"));
          reject(err);
        });
    });
  };
}

export function updateCarrierLanePreferences(carrier_id, data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      updateCarrierLanePreferencesApi(carrier_id, data)
        .then(res => {
          dispatch(fetchSuccess());
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError((err.response && err.response.data.message) ?? "Some error occured while updating lane preferences"));
          reject(err);
        });
    });
  };
}

export function deleteCarrierLanePreferences(carrier_id, data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      deleteCarrierLanePreferencesApi(carrier_id, data)
        .then(res => {
          dispatch(fetchSuccess());
          resolve(res);
        })
        .catch(err => {
          dispatch(fetchError((err.response && err.response.data.message) ?? "Some error occured while deleting lane preferences"));
          reject(err);
        });
    });
  };
}
